<template>
  <v-container fluid grid-list-md class="pa-3">
    <v-layout row wrap>
      <v-flex xs12 md3>
        <v-card flat class="v2-card">
          <v-card-title>Quick Information</v-card-title>
          <iframe width="100%" height="260" frameborder="0" style="border:0; display:block;" :src="getgooglemap(companyAddress.company_street, companyAddress.company_city, companyAddress.company_state, companyAddress.company_zip)" allowfullscreen></iframe>
          <v-list two-line class="pb-0">
            <v-list-tile>
              <v-list-tile-action><v-icon color="primary">business</v-icon></v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-sub-title>Company Legal Name</v-list-tile-sub-title>
                <v-list-tile-title class="font-weight-medium">{{ company.company_name }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-action></v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-sub-title>DBA</v-list-tile-sub-title>
                <v-list-tile-title class="font-weight-medium">{{ company.company_dba }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider inset></v-divider>
            <v-list-tile>
              <v-list-tile-action><v-icon color="primary">date_range</v-icon></v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-sub-title>Industry Type</v-list-tile-sub-title>
                <v-list-tile-title>{{ company.company_industry }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-action></v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-sub-title>Start Date · Time in Biz</v-list-tile-sub-title>
                <v-list-tile-title>
                  {{ formatStartDate(company.company_started_date) }} ·
                  <span :class="timeBusinessClass">{{ timeBusiness }} year(s)</span>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider inset></v-divider>
            <v-list-tile>
              <v-list-tile-action><v-icon color="primary">location_on</v-icon></v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-sub-title>Company Address</v-list-tile-sub-title>
                <v-list-tile-title>{{ companyAddress.company_street }}, {{ companyAddress.company_city }}, {{ companyAddress.company_state }} {{ companyAddress.company_zip }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider></v-divider>
            <template v-for="(m, i) in companyMerchants">
              <v-list-tile :key="'m' + i">
                <v-list-tile-action><v-icon color="primary">account_box</v-icon></v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-sub-title>Merchant</v-list-tile-sub-title>
                  <v-list-tile-title>{{ m.merchant_first_name }} {{ m.merchant_last_name }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile :key="'c' + i">
                <v-list-tile-action><v-icon color="primary">credit_card</v-icon></v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-sub-title>Credit Score · Ownership</v-list-tile-sub-title>
                  <v-list-tile-title>{{ m.merchant_credit_score }} · {{ m.percentage_of_ownership }}%</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider :key="'d' + i"></v-divider>
            </template>
          </v-list>
        </v-card>
      </v-flex>

      <v-flex xs12 md9>
        <v-card flat class="v2-card mb-3">
          <v-card-title>Bank Statement Monthly Averages</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex v-for="t in averageTiles" :key="t.label" xs6 sm4 md2>
                <v-card flat class="v2-card v2-panel pa-2">
                  <div class="v2-kpi-label">{{ t.label }}</div>
                  <div class="font-weight-bold" :class="{ 'error--text': t.alert }">{{ t.value }}</div>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>

          <v-expansion-panel v-model="panel" expand class="elevation-0">
            <v-expansion-panel-content v-for="(accountItem, index) in bankAccounts" :key="index">
              <div slot="header" class="font-weight-bold">{{ accountItem.bank_account_name }}</div>
              <div class="v2-table-scroll">
                <v-data-table :headers="monthHeaders" :items="fcsRow[index].data" hide-actions :pagination.sync="allRows" no-data-text="No bank statement has been added.">
                  <template slot="items" slot-scope="props">
                    <td>{{ formatMonth(props.item.month_name) }}</td>
                    <td class="text-xs-right">${{ formatPrice(props.item.month_deposit_amount) }}</td>
                    <td class="text-xs-right">${{ formatPrice(props.item.month_transfer_amount) }}</td>
                    <td class="text-xs-right">${{ formatPrice(props.item.month_other_advances) }}</td>
                    <td class="text-xs-right">${{ formatPrice(props.item.month_deduction) }}</td>
                    <td class="text-xs-right">${{ formatPrice(props.item.month_net_deposits) }}</td>
                    <td class="text-xs-right">{{ props.item.month_number_of_deposits }}</td>
                    <td class="text-xs-right">{{ props.item.month_negative_days }}</td>
                    <td class="text-xs-right">${{ formatPrice(props.item.month_average_balance) }}</td>
                    <td class="text-xs-right">${{ formatPrice(props.item.month_monthly_beginning_balance) }}</td>
                    <td class="text-xs-right">${{ formatPrice(props.item.month_monthly_ending_balance) }}</td>
                  </template>
                  <template slot="footer">
                    <tr class="font-weight-bold">
                      <td>Averages:</td>
                      <td class="text-xs-right">${{ formatPrice(caculateAverage(index, 'month_deposit_amount')) }}</td>
                      <td class="text-xs-right">${{ formatPrice(caculateAverage(index, 'month_transfer_amount')) }}</td>
                      <td class="text-xs-right">${{ formatPrice(caculateAverage(index, 'month_other_advances')) }}</td>
                      <td class="text-xs-right">${{ formatPrice(caculateAverage(index, 'month_deduction')) }}</td>
                      <td class="text-xs-right">${{ formatPrice(caculateAverage(index, 'month_net_deposits')) }}</td>
                      <td class="text-xs-right">{{ caculateAverage(index, 'month_number_of_deposits') }}</td>
                      <td class="text-xs-right">{{ caculateAverage(index, 'month_negative_days') }}</td>
                      <td class="text-xs-right">${{ formatPrice(caculateAverage(index, 'month_average_balance')) }}</td>
                      <td class="text-xs-right">${{ formatPrice(caculateAverage(index, 'month_monthly_beginning_balance')) }}</td>
                      <td class="text-xs-right">${{ formatPrice(caculateAverage(index, 'month_monthly_ending_balance')) }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-card>

        <v-card flat class="v2-card mb-3">
          <v-card-title>
            Account Aggregation
            <v-spacer></v-spacer>
            <v-btn small depressed color="primary" @click="sheet = true"><v-icon small left>show_chart</v-icon>Show Chart</v-btn>
          </v-card-title>
          <v-bottom-sheet v-if="sheet" v-model="sheet" inset>
            <v-sheet class="pa-2"><highcharts :options="chartOptions"></highcharts></v-sheet>
          </v-bottom-sheet>
          <div class="v2-table-scroll">
            <v-data-table :headers="monthHeaders" :items="fcsCompanyRow" hide-actions no-data-text="No bank statement has been added.">
              <template slot="items" slot-scope="props">
                <td>{{ formatMonth(props.item.month_name) }}</td>
                <td class="text-xs-right">${{ formatPrice(props.item.month_deposit_amount) }}</td>
                <td class="text-xs-right">${{ formatPrice(props.item.month_transfer_amount) }}</td>
                <td class="text-xs-right">${{ formatPrice(props.item.month_other_advances) }}</td>
                <td class="text-xs-right">${{ formatPrice(props.item.month_deduction) }}</td>
                <td class="text-xs-right">${{ formatPrice(props.item.month_net_deposits) }}</td>
                <td class="text-xs-right">{{ props.item.month_number_of_deposits }}</td>
                <td class="text-xs-right">{{ props.item.month_negative_days }}</td>
                <td class="text-xs-right">${{ formatPrice(props.item.month_average_balance) }}</td>
                <td class="text-xs-right">${{ formatPrice(props.item.month_monthly_beginning_balance) }}</td>
                <td class="text-xs-right">${{ formatPrice(props.item.month_monthly_ending_balance) }}</td>
              </template>
              <template slot="footer">
                <tr class="font-weight-bold">
                  <td>Averages:</td>
                  <td class="text-xs-right">${{ formatPrice(caculateTotalAverageForAgg.deposit_amount) }}</td>
                  <td class="text-xs-right">${{ formatPrice(caculateTotalAverageForAgg.trans_amount) }}</td>
                  <td class="text-xs-right">${{ formatPrice(caculateTotalAverageForAgg.other_advance) }}</td>
                  <td class="text-xs-right">${{ formatPrice(caculateTotalAverageForAgg.month_deduction) }}</td>
                  <td class="text-xs-right">${{ formatPrice(caculateTotalAverageForAgg.net_deposit) }}</td>
                  <td class="text-xs-right">{{ caculateTotalAverageForAgg.number_deposit }}</td>
                  <td class="text-xs-right">{{ caculateTotalAverageForAgg.negative_days }}</td>
                  <td class="text-xs-right">${{ formatPrice(caculateTotalAverageForAgg.daily_balance) }}</td>
                  <td class="text-xs-right">${{ formatPrice(caculateTotalAverageForAgg.month_monthly_beginning_balance) }}</td>
                  <td class="text-xs-right">${{ formatPrice(caculateTotalAverageForAgg.month_monthly_ending_balance) }}</td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-card>

        <v-card flat class="v2-card mb-3">
          <v-card-title>MCA Information</v-card-title>
          <div class="v2-table-scroll">
            <v-data-table :headers="mcaHeaders" :items="mcaRows" hide-actions>
              <template slot="items" slot-scope="props">
                <tr :class="{ 'v2-paid-off': isPaidOff(props.item.status) }">
                  <td>{{ getBankName(props.item.bank_account_id) }}</td>
                  <td class="text-xs-right">${{ formatPrice(props.item.mca_daily_payment) }}</td>
                  <td class="text-xs-right">${{ formatPrice(props.item.mca_weekly_payment) }}</td>
                  <td class="text-xs-right"><span v-if="props.item.mca_balance != '0'">${{ formatPrice(props.item.mca_balance) }}</span></td>
                  <td class="text-xs-right"><span v-if="props.item.mca_original_funding_amount != '0'">${{ formatPrice(props.item.mca_original_funding_amount) }}</span></td>
                  <td class="text-xs-right font-weight-bold">{{ props.item.with_hold }}%</td>
                  <td>{{ props.item.lender_name }}</td>
                  <td>{{ props.item.status }}</td>
                  <td>{{ props.item.mca_date }}</td>
                  <td>
                    <a v-if="props.item.description != null && props.item.description.includes('MID: ')" class="v2-highlight" :href="props.item.previous_deal_url" target="_blank">{{ props.item.description }}</a>
                    <v-tooltip v-else bottom>
                      <div slot="activator" class="v2-highlight v2-ellipsis">{{ props.item.description }}</div>
                      <span>{{ props.item.description }}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
              <template slot="footer">
                <tr class="font-weight-bold">
                  <td>Totals:</td>
                  <td class="text-xs-right">${{ formatPrice(caculateTotalSum.mca_daily_payment) }}</td>
                  <td class="text-xs-right">${{ formatPrice(caculateTotalSum.mca_weekly_payment) }}</td>
                  <td class="text-xs-right">${{ formatPrice(caculateTotalSum.mca_balance) }}</td>
                  <td class="text-xs-right">${{ formatPrice(caculateTotalSum.mca_original_funding_amount) }}</td>
                  <td class="text-xs-right">
                    {{ formatPrice(caculateTotalSum.total_with_hold) }}%
                    <v-tooltip bottom>
                      <v-icon slot="activator" small color="primary">info</v-icon>
                      <span>Total withhold includes active pulling MCA/s only.</span>
                    </v-tooltip>
                  </td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td></td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-card>

        <v-card flat class="v2-card">
          <v-card-title>Our Offer</v-card-title>
          <div class="v2-table-scroll">
            <v-data-table :headers="offerHeaders" :items="dealLenders" :pagination.sync="offerPagination" hide-actions expand>
              <template slot="items" slot-scope="props">
                <tr class="v2-row" @click="props.expanded = !props.expanded">
                  <td>{{ props.item.lender_position_number }}</td>
                  <td>{{ props.item.lender_offer_amount | currency }}</td>
                  <td>{{ props.item.lender_payback_amount | currency }}</td>
                  <td>{{ props.item.lender_term }}</td>
                  <td>{{ props.item.lender_payment | currency }} <strong>{{ props.item.lender_payment_type }}</strong></td>
                  <td class="font-weight-bold">{{ caculateWithholdAverage(props.item.lender_payment, props.item.lender_payment_type) }}%</td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ formatOfferDate(props.item.created_at) }}</td>
                </tr>
              </template>
              <template slot="expand" slot-scope="props">
                <div class="v2-expand pa-3">
                  <v-layout row wrap>
                    <v-flex xs12 md6><div class="v2-kpi-label">ISO Notification Message</div><div v-html="props.item.offer_notify_note"></div></v-flex>
                    <v-flex xs12 md6><div class="v2-kpi-label">Internal Notes</div><div v-html="props.item.offer_note"></div></v-flex>
                  </v-layout>
                </div>
              </template>
              <template slot="no-data"><p class="ma-0 v2-muted">No data</p></template>
            </v-data-table>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import fcs_helper from '../../helpers/fcs_helper'
import fcsChart from '../mixins/fcsChart'

const right = (text, extra) => ({ text, align: 'right', sortable: false, ...extra })

export default {
  mixins: [fcs_helper, fcsChart],
  data: () => ({
    panel: [true],
    sheet: false,
    allRows: { rowsPerPage: -1 },
    offerPagination: { sortBy: 'created_at', descending: true, rowsPerPage: -1 },
    monthHeaders: [
      { text: 'Month', sortable: false },
      right('Total Deposits'), right('Transfer Amt'), right('Other Advances'), right('Misc Deductions'), right('Net Deposits'),
      right('# of Deposits'), right('NSF'), right('Average Bal'), right('Beginning Bal'), right('Ending Bal'),
    ],
    mcaHeaders: [
      { text: 'Bank Account', sortable: false },
      right('Daily Payment', { value: 'mca_daily_payment' }), right('Weekly Payment', { value: 'mca_weekly_payment' }),
      right('Balance', { value: 'mca_balance' }), right('Original Funding Amt', { value: 'mca_original_funding_amount' }),
      right('Withhold', { value: 'mca_withold' }),
      { text: 'Lender', value: 'lender_id', sortable: false }, { text: 'Status', sortable: false },
      { text: 'Funded Date', value: 'mca_date', sortable: false }, { text: 'Description', sortable: false },
    ],
    offerHeaders: [
      { text: 'Position', value: 'lender_position_number' },
      { text: 'Offer Amount', value: 'lender_offer_amount' },
      { text: 'Payback Amount', value: 'lender_payback_amount' },
      { text: 'Term(days)', value: 'lender_term' },
      { text: 'Payment', value: 'mca_daily_payment' },
      { text: 'Withhold', value: 'mca_withold' },
      { text: 'Lender', value: 'lender_id' },
      { text: 'Funding Date', value: 'mca_date' },
    ],
  }),
  computed: {
    timeBusinessClass() {
      if (this.timeBusiness < 1) return 'error--text'
      if (this.timeBusiness <= 3) return 'warning--text'
      return 'success--text'
    },
    averageTiles() {
      const a = this.caculateTotalAverageForAgg
      return [
        { label: 'Avg Deposit Amount', value: '$' + this.formatPrice(a.deposit_amount) },
        { label: 'Avg Other Advances', value: '$' + this.formatPrice(a.other_advance) },
        { label: 'Avg Transfer Amount', value: '$' + this.formatPrice(a.trans_amount) },
        { label: 'Avg Misc Deduction', value: '$' + this.formatPrice(a.month_deduction) },
        { label: 'Avg Net Deposit', value: '$' + this.formatPrice(a.net_deposit), alert: a.net_deposit < 15000 },
        { label: 'Avg Number of Deposits', value: this.formatPrice(a.number_deposit) },
        { label: 'Avg Negative Days', value: this.formatPrice(a.negative_days) },
        { label: 'Average Daily Balance', value: '$' + this.formatPrice(a.daily_balance) },
        { label: 'Avg Beginning Balance', value: '$' + this.formatPrice(a.month_monthly_beginning_balance) },
        { label: 'Avg Ending Balance', value: '$' + this.formatPrice(a.month_monthly_ending_balance) },
      ]
    },
  },
  methods: {
    formatStartDate(date) {
      return moment(date, 'MMYYYY').format('MM/YYYY')
    },
    formatMonth(date) {
      return moment(date, 'YYYY-MM-DD').format('YYYY-MM')
    },
    formatOfferDate(date) {
      return moment(date, 'MM/DD/YYYY, h:mma')
    },
    caculateAverage(index, key_name) {
      const rows = this.fcsRow[index].data
      const scrubbed = _.filter(rows, o => o.calculate_row != 0)
      const sum = scrubbed.length == 0 ? 0 : _.sumBy(rows, res => (res.calculate_row != 0 && res[key_name] != null ? parseFloat(res[key_name]) : 0)) / scrubbed.length
      return sum.toFixed(2)
    },
    isPaidOff(status) {
      return status == 'paying off' || status == 'paid off'
    },
    getBankName(bank_id) {
      const name = _.filter(this.bankAccounts, o => o.id == bank_id)
      return name && name.length > 0 ? name[0].bank_account_name : ''
    },
  },
}
</script>

<style scoped>
.v2-paid-off td { background: #F1F5F9; color: #64748B; }
.v2-highlight { background: #FEF08A; padding: 0 4px; border-radius: 4px; }
.v2-ellipsis { max-width: 150px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
</style>
